import { InjectionToken } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

export const API_URL = new InjectionToken<string>('');

const providers = [{ provide: API_URL, useFactory: getBaseUrl, deps: [] }];

platformBrowserDynamic(providers)
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
